import request from '@/utils/httpRequest'

export function getRoleList (params) {
  return request({
    url: `/sys/role/list`,
    method: 'get',
    params
  })
}

export function update (data) {
  return request({
    url: `/sys/role/update`,
    method: 'post',
    data
  })
}

export function saveRole (data) {
  return request({
    url: `/sys/role/save`,
    method: 'post',
    data
  })
}

export function deleteRole (data) {
  return request({
    url: `/sys/role/delete`,
    method: 'post',
    data
  })
}

export function getAllMenuList (params) {
  return request({
    url: `/sys/menu/allList`,
    method: 'get',
    params
  })
}

export function getRoleInfo (roleId, params) {
  return request({
    url: `/sys/role/info/${roleId}`,
    method: 'get',
    params
  })
}
